// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-next',
  revision: 'b080cd8c5',
  branch: 'next',
  date: 'Tue, 25 Aug 2026 15:48:49 GMT'
};